import API from "../axiosConfig";


export const getClientsWithoutPaginate = async () => {
  try {
    const response = await API.get("/clients", { params: { no_paginate: true } });
    return response.data;
  } catch (error) {
    console.error("Error fetching clients without pagination:", error);
    throw error;
  }
}
export const getClientSearch = async (params) => {
  try {
    const response = await API.get("/clients", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching clients:", error);
    throw error;
  }
};

// export const getClientSearch = async (params) => {
//   try {
//     const response = await API.get("/clients-search", { params });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching clients:", error);
//     throw error;
//   }
// };

export const getClientById = async (id) => {
  try {
    const response = await API.get(`/clients/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createClient = async (clientData) => {
  try {
    const response = await API.post("/clients", clientData);
    return response.data;
  } catch (error) {
    console.error("Error creating client:", error);
    throw error;
  }
};

export const updateClient = async (clientId, clientData) => {
  try {
    const response = await API.put(`/clients/${clientId}`, clientData);
    return response.data;
  } catch (error) {
    console.error("Error updating client:", error);
    throw error;
  }
};

// export const deleteClient = async (clientId) => {
//   try {
//     const response = await API.delete(`/clients/${clientId}`);
//     return response.data;
//   } catch (error) {
//     console.error("Error deleting client:", error);
//     throw error;
//   }
// };

export const uploadClientDocuments = async (clientId, documentData) => {
  try {
    const response = await API.post(
      `/clients/${clientId}/documents`,
      documentData
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading document:", error);
    throw error;
  }
};

export const deleteClientDocument = async (clientId, documentName) => {
  try {
    const response = await API.put(
      `/clients/${clientId}/documents`,
      documentName
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting document:", error);
    throw error;
  }
};

export const getClientNames = async () => {
  try {
    const response = await API.get("/clients-names");
    return response.data;
  } catch (error) {
    console.error("Error fetching client names:", error);
    throw error;
  }
};

export const changeSubscriptionClient = async (subscriptionId, clientId, reason) => {
  try {
    const response = await API.put(`/subscriptions/${subscriptionId}/change-client`, {
      client_id: clientId,
      reason: reason,
    });
    return response.data;
  } catch (error) {
    console.error("Error changing subscription client:", error);
    throw error;
  }
};


